import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SchedulingState } from '../types';

const initialState: SchedulingState = {
  currentGTId: '',
  schedulerInfo: {
    drawer: false,
    loader: false,
  },
};

export const schedulingSlice = createSlice({
  name: 'scheduling',
  initialState,
  reducers: {
    setCurrentGTId: (state, action) => {
      state.currentGTId = action.payload;
    },
    clearCurrentGTId: (state) => {
      state.currentGTId = '';
    },
    resetScheduling: () => initialState,
    toggleSchedulerInfoDrawer: (state, action: PayloadAction<{ drawer: boolean }>) => {
      state.schedulerInfo.drawer = action.payload.drawer;
    },
  },
});

export const { setCurrentGTId, clearCurrentGTId, resetScheduling, toggleSchedulerInfoDrawer } = schedulingSlice.actions;
export default schedulingSlice.reducer;
